<ng-container *ngIf="isBrowser">
    <div class="tmp-section-item-wrapper">
        <span multilang class="tmp-section-title">{{'Weiterempfehlung'}}</span>
        <div class="tmp-section-body tmp-flexy">
            <button class="tmp-f-btn" [class.tmp-f-btn-selected]="currentSelected === 70" (click)="selectValue(70)"
                matRipple>min 70%</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentSelected === 80"
                (click)="selectValue(80)" matRipple>min 80%</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentSelected === 90"
                (click)="selectValue(90)" matRipple>min 90%</button>
            <button class="tmp-f-btn tmp-m-left" [class.tmp-f-btn-selected]="currentSelected === 95"
                (click)="selectValue(95)" matRipple>min 95%</button>
        </div>
    </div>
</ng-container>